import { comics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function RankingSection() {
  const top10 = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
          <div>
            <div className="mb-8">
              <span className="text-xs font-medium tracking-widest uppercase text-secondary-500">
                排行榜
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-3">
                本周热门排行
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                根据阅读量和评分综合排序
              </p>
            </div>

            <div className="space-y-3">
              {top10.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="flex items-center gap-4 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all group"
                >
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                    index === 0
                      ? 'bg-accent-500 text-background-50'
                      : index === 1
                      ? 'bg-secondary-400 text-background-50'
                      : index === 2
                      ? 'bg-primary-400 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </div>
                  <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                    <img
                      src={comic.coverUrl}
                      alt={comic.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs text-accent-600">
                        <i className="ri-star-fill text-xs"></i> {comic.rating}
                      </span>
                      <span className="text-xs text-foreground-400">
                        {comic.chapters.length}话
                      </span>
                    </div>
                  </div>
                  <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
                    <span className="px-2 py-0.5 rounded-full bg-background-100">{comic.categories[0] === 'romance' ? '恋爱' : comic.categories[0] === 'fantasy' ? '奇幻' : comic.categories[0] === 'action' ? '动作' : comic.categories[0] === 'thriller' ? '悬疑' : comic.categories[0] === 'comedy' ? '搞笑' : comic.categories[0] === 'drama' ? '剧情' : comic.categories[0] === 'horror' ? '恐怖' : '日常'}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-8">
              <span className="text-xs font-medium tracking-widest uppercase text-accent-500">
                最新上线
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-3">
                新作首发
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                第一时间体验最新上架的韩漫作品
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {comics.filter((c) => c.isNew).slice(0, 4).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all"
                >
                  <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                    <img
                      src={comic.coverUrl}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50">
                      NEW
                    </span>
                  </div>
                  <div className="p-3 text-center">
                    <h4 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <p className="text-xs text-foreground-400 mt-1">{comic.author}</p>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-8 p-6 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
              <h3 className="font-heading text-xl font-bold">追更提醒</h3>
              <p className="mt-2 text-sm text-background-50/80">
                添加到收藏夹，第一时间收到心仪漫画的更新通知，精彩内容不再错过。
              </p>
              <Link
                to="/category/all"
                className="whitespace-nowrap mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-50 text-primary-600 text-sm font-medium hover:bg-background-100 transition-colors"
              >
                探索更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}